

import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  FaStar,
  FaFilter,
  FaChevronDown,
  FaTimes,
  FaPaperclip,
  FaCheckCircle,
  FaClock,
  FaCalendarAlt,
  FaWallet,
  FaTruck,
  FaUtensils,
  FaSpinner,
  FaFileInvoice,
  FaRedo,
  FaMotorcycle,
  FaMapMarkerAlt,
  FaHome,
  FaStore,
  FaChair,
  FaPhoneAlt,
  FaWalking,
  FaConciergeBell
} from "react-icons/fa";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import InvoicePopup from '../../Tablemenu/InvoicePopup.jsx';
import { GoogleMap, Marker, Polyline } from '@react-google-maps/api';
import './Myorder.css'

// Google Maps API Key
const GOOGLE_MAPS_API_KEY = "AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ";

// Default center (Hyderabad)
const DEFAULT_CENTER = { lat: 17.3850, lng: 78.4867 };

const mapContainerStyle = {
  width: "100%",
  height: "300px",
  borderRadius: "12px"
};

// Helper function to decode polyline
const decodePolyline = (encoded) => {
  if (!encoded) return [];
  let points = [];
  let index = 0, len = encoded.length;
  let lat = 0, lng = 0;

  while (index < len) {
    let b, shift = 0, result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    const dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
    lat += dlat;

    shift = 0;
    result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    const dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
    lng += dlng;

    points.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }
  return points;
};

// DeliveryMap Component
const DeliveryMap = ({
  restaurantPosition,
  destinationPosition,
  currentPosition,
  deliveryRoute
}) => {
  const [map, setMap] = useState(null);

  // Custom marker icons
  const getBikeMarkerIcon = () => {
    if (!window.google) return null;
    return {
      url: "https://cdn-icons-png.flaticon.com/512/3096/3096117.png",
      scaledSize: new window.google.maps.Size(40, 40),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(20, 20)
    };
  };

  const getRestaurantMarkerIcon = () => {
    if (!window.google) return null;
    return {
      url: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png",
      scaledSize: new window.google.maps.Size(35, 35),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(17, 17)
    };
  };

  const getHomeMarkerIcon = () => {
    if (!window.google) return null;
    return {
      url: "https://cdn-icons-png.flaticon.com/512/25/25694.png",
      scaledSize: new window.google.maps.Size(35, 35),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(17, 17)
    };
  };

  const getMapCenter = () => {
    if (currentPosition) return currentPosition;
    if (restaurantPosition) return restaurantPosition;
    if (destinationPosition) return destinationPosition;
    return DEFAULT_CENTER;
  };

  const fitBounds = useCallback(() => {
    if (map && window.google && restaurantPosition && destinationPosition) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(restaurantPosition);
      bounds.extend(destinationPosition);
      map.fitBounds(bounds);
    }
  }, [map, restaurantPosition, destinationPosition]);

  const onMapLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  useEffect(() => {
    if (map) {
      fitBounds();
    }
  }, [map, restaurantPosition, destinationPosition, fitBounds]);

  const mapCenter = getMapCenter();

  return (
    <div className="premiumOrder-liveMapContainer">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={mapCenter}
        zoom={13}
        onLoad={onMapLoad}
        options={{
          disableDefaultUI: false,
          zoomControl: true,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: true
        }}
      >
        {/* Restaurant Marker */}
        {restaurantPosition && window.google && (
          <Marker
            position={restaurantPosition}
            icon={getRestaurantMarkerIcon()}
            title="Restaurant"
          />
        )}

        {/* Destination Marker */}
        {destinationPosition && window.google && (
          <Marker
            position={destinationPosition}
            icon={getHomeMarkerIcon()}
            title="Your Location"
          />
        )}

        {/* Delivery Bike Marker */}
        {currentPosition && window.google && (
          <Marker
            position={currentPosition}
            icon={getBikeMarkerIcon()}
            title="Delivery Partner"
            animation={window.google.maps.Animation.BOUNCE}
          />
        )}

        {/* Route Polyline */}
        {deliveryRoute && deliveryRoute.overview_polyline && window.google && (
          <Polyline
            path={decodePolyline(deliveryRoute.overview_polyline.points)}
            options={{
              strokeColor: "#FF6B35",
              strokeOpacity: 0.8,
              strokeWeight: 4
            }}
          />
        )}
      </GoogleMap>



    </div>
  );
};

// Main Component
const OrderPremium = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [filters, setFilters] = useState({
    name: "",
    orderType: "",
    paymentMethod: "",
    status: ""
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2026");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedWeek, setSelectedWeek] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showSupportPopup, setShowSupportPopup] = useState(false);
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const [showInvoicePopup, setShowInvoicePopup] = useState(false);
  const [showTrackingPopup, setShowTrackingPopup] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [ticketType, setTicketType] = useState("");
  const [message, setMessage] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [hoverRating, setHoverRating] = useState(0);
  const [isSubmittingRating, setIsSubmittingRating] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [file, setFile] = useState(null);
  const [trackingOrder, setTrackingOrder] = useState(null);
  const [deliveryPartner, setDeliveryPartner] = useState(null);
  const [trackingProgress, setTrackingProgress] = useState(0);
  const [estimatedTime, setEstimatedTime] = useState(null);
  const [loadingTracking, setLoadingTracking] = useState(false);
  const [waiterInfo, setWaiterInfo] = useState(null);
  const [tableInfo, setTableInfo] = useState(null);
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);

  // Google Maps states
  const [deliveryRoute, setDeliveryRoute] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(null);
  const [destinationPosition, setDestinationPosition] = useState(null);
  const [restaurantPosition, setRestaurantPosition] = useState(null);
  const animationFrameRef = useRef(null);

  const navigate = useNavigate();

  const itemsPerPage = 6;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  const orderTypeOptions = ["DINE_IN", "TAKEAWAY", "DELIVERY", "PICKUP"];
  const paymentOptions = ["CREDIT_CARD", "DEBIT_CARD", "UPI", "CASH", "WALLET"];
  const statusOptions = ["PENDING", "CONFIRMED", "PREPARING", "OUT_FOR_DELIVERY", "DELIVERED", "CANCELLED"];
  const ticketTypeOptions = [
    "DELIVERY_ISSUE",
    "PAYMENT_PROBLEM",
    "WRONG_ORDER",
    "SERVICE_QUALITY",
    "OTHER"
  ];

  // Check if Google Maps is loaded
  useEffect(() => {
    const checkGoogleMaps = setInterval(() => {
      if (window.google && window.google.maps) {
        setIsGoogleMapsLoaded(true);
        clearInterval(checkGoogleMaps);
      }
    }, 100);

    return () => clearInterval(checkGoogleMaps);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get order progress based on status
  const getOrderProgress = (status) => {
    const progressMap = {
      'HOLD': 0,
      'PENDING': 5,
      'CONFIRMED': 20,
      'PROCESSING': 35,
      'BEING_PREPARED': 50,
      'ORDER_IS_READY': 65,
      'WAITING_FOR_PICKUP': 75,
      'ON_THE_WAY': 85,
      'OUT_FOR_DELIVERY': 85,
      'DELIVERED': 100,
      'COMPLETED': 100,
      'CANCELLED': 0
    };
    return progressMap[status] || 0;
  };

  // Calculate route between two points
  const calculateRoute = async (origin, destination) => {
    if (!origin || !destination || !window.google) return null;

    try {
      const directionsService = new window.google.maps.DirectionsService();
      const result = await new Promise((resolve, reject) => {
        directionsService.route(
          {
            origin: origin,
            destination: destination,
            travelMode: window.google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              resolve(response.routes[0]);
            } else {
              reject(new Error("Directions request failed"));
            }
          }
        );
      });
      return result;
    } catch (error) {
      console.error("Error calculating route:", error);
      return null;
    }
  };

  // Animate bike movement
  const animateBikeAlongRoute = (route, durationSeconds = 30) => {
    if (!route || !route.overview_polyline || !window.google) return;

    const points = decodePolyline(route.overview_polyline.points);
    if (points.length < 2) return;

    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    let step = 0;
    const totalSteps = points.length - 1;
    const stepDuration = (durationSeconds * 1000) / totalSteps;
    let lastTimestamp = 0;

    const animate = (timestamp) => {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const elapsed = timestamp - lastTimestamp;

      if (elapsed >= stepDuration && step < totalSteps) {
        step++;
        const newPosition = points[step];
        setCurrentPosition(newPosition);

        const progressPercent = (step / totalSteps) * 100;
        setTrackingProgress(Math.min(progressPercent, 100));

        lastTimestamp = timestamp;
      }

      if (step < totalSteps) {
        animationFrameRef.current = requestAnimationFrame(animate);
      }
    };

    animationFrameRef.current = requestAnimationFrame(animate);
  };

  // Fetch delivery details from the delivery API
  const fetchDeliveryDetails = async (orderId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `https://backend.maamaas.com/delivery/api/get/order?orderId=11&appType=FOOD_AND_BEVERAGES`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );

      if (response.status === 200 && response.data) {
        const data = response.data;

        // Extract coordinates from API response
        const partnerLat = parseFloat(data.deliveryPartnerLatiude);
        const partnerLng = parseFloat(data.deliveryPartnerLongitude);
        const vendorLat = parseFloat(data.vendorLatitude);
        const vendorLng = parseFloat(data.vendorLongitude);
        const userLat = parseFloat(data.userLatitude);
        const userLng = parseFloat(data.userLongitude);

        console.log("Delivery API Response:", {
          partner: { lat: partnerLat, lng: partnerLng },
          vendor: { lat: vendorLat, lng: vendorLng },
          user: { lat: userLat, lng: userLng }
        });

        // Set restaurant position from vendor coordinates
        if (!isNaN(vendorLat) && !isNaN(vendorLng) && vendorLat !== 0) {
          setRestaurantPosition({ lat: vendorLat, lng: vendorLng });
        }

        // Set destination position from user coordinates
        if (!isNaN(userLat) && !isNaN(userLng) && userLat !== 0) {
          setDestinationPosition({ lat: userLat, lng: userLng });
        }

        // Set current position from delivery partner coordinates
        if (!isNaN(partnerLat) && !isNaN(partnerLng) && partnerLat !== 0) {
          setCurrentPosition({ lat: partnerLat, lng: partnerLng });
        }

        // Set delivery partner info
        setDeliveryPartner({
          name: data.deliveryPartnerName || "Delivery Partner",
          phone: data.userPhone,
          vehicleNumber: data.vehicleStatus,
          lat: partnerLat,
          lng: partnerLng,
          userOtp: data.userOtp,
          vendorOtp: data.vendorOtp
        });

        // Set estimated time if available
        if (data.estimatedDeliveryTimeMinutes) {
          setEstimatedTime(`${data.estimatedDeliveryTimeMinutes} mins`);
        } else if (data.deliveryDistanceKm) {
          // Calculate estimated time based on distance (average 30 km/h)
          const distanceKm = parseFloat(data.deliveryDistanceKm);
          const estimatedMinutes = Math.ceil(distanceKm / 30 * 60);
          setEstimatedTime(`${estimatedMinutes} mins`);
        }

        return data;
      }
    } catch (error) {
      console.error("Error fetching delivery details:", error);
      return null;
    }
  };

  // Setup delivery tracking using the delivery API
  const setupDeliveryTracking = async (order) => {
    setLoadingTracking(true);

    try {
      // Fetch delivery details from the delivery API
      const deliveryData = await fetchDeliveryDetails(order.orderId);

      if (deliveryData) {
        console.log("Delivery data loaded successfully:", deliveryData);

        // Calculate route after positions are set
        setTimeout(async () => {
          // Use vendor position as start if available, otherwise use current position
          let startPoint = currentPosition;
          if (!startPoint && restaurantPosition) {
            startPoint = restaurantPosition;
          }

          if (startPoint && destinationPosition && window.google) {
            const route = await calculateRoute(startPoint, destinationPosition);
            if (route) {
              setDeliveryRoute(route);

              // Start animation if order status is appropriate
              if (order.status === "OUT_FOR_DELIVERY" || order.status === "ON_THE_WAY") {
                const durationSeconds = route.legs[0]?.duration?.value || 1800;
                animateBikeAlongRoute(route, durationSeconds);
              }
            }
          }
        }, 500);
      }

      setTrackingProgress(getOrderProgress(order.status));

    } catch (error) {
      console.error("Error setting up delivery tracking:", error);
    } finally {
      setLoadingTracking(false);
    }
  };

  // Fetch orders from food API
  const fetchOrders = async () => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('authToken');

    if (!userId) {
      console.error('User ID not found');
      return;
    }

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/user/orders?userId=${userId}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      const sortedOrders = response.data.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      setOrders(sortedOrders);
      setFilteredOrders(sortedOrders);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    let result = orders;

    if (selectedYear) {
      result = result.filter(order =>
        new Date(order.orderDateAndTime).getFullYear().toString() === selectedYear
      );
    }

    if (selectedMonth) {
      result = result.filter(order =>
        (new Date(order.orderDateAndTime).getMonth() + 1).toString() === selectedMonth
      );
    }

    if (selectedWeek) {
      result = result.filter(order =>
        getWeekOfMonth(order.orderDateAndTime).toString() === selectedWeek
      );
    }

    if (filters.name) {
      result = result.filter(order =>
        order.dishName?.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    if (filters.orderType) {
      result = result.filter(order => order.orderType === filters.orderType);
    }

    if (filters.paymentMethod) {
      result = result.filter(order => order.paymentMethod === filters.paymentMethod);
    }

    if (filters.status) {
      result = result.filter(order => order.status === filters.status);
    }

    setFilteredOrders(result);
    setCurrentPage(1);
  }, [selectedYear, selectedMonth, selectedWeek, filters, orders]);

  const getWeekOfMonth = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    return Math.ceil(day / 7);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const clearFilters = () => {
    setFilters({ name: "", orderType: "", paymentMethod: "", status: "" });
    setSelectedYear("2025");
    setSelectedMonth("");
    setSelectedWeek("");
  };

  const handleSend = async () => {
    if (!ticketType || !message) {
      alert("Please fill in all required fields");
      return;
    }

    const userId = Number(localStorage.getItem("userId"));
    const token = localStorage.getItem("authToken");

    const formData = new FormData();

    const ticketData = new Blob(
      [
        JSON.stringify({
          userId: userId || 0,
          ticketType,
          message,
          attachmentUrl: "",
        }),
      ],
      { type: "application/json" }
    );

    formData.append("ticketData", ticketData);

    if (file) {
      formData.append("attachment", file);
    }

    try {
      const res = await fetch(
        `https://backend.maamaas.com/food/api/tickets/create/${orderId}`,
        {
          method: "POST",
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: formData,
        }
      );

      const text = await res.text();

      if (!res.ok) throw new Error(text);

      alert("Ticket raised successfully!");
      setShowSupportPopup(false);
      setTicketType("");
      setMessage("");
      setFile(null);
    } catch (err) {
      console.error(err);
      alert("Error: " + err.message);
    }
  };

  const handleViewInvoice = async (order) => {
    setLoadingInvoice(true);
    setOrderId(order.orderId);

    try {
      const token = localStorage.getItem("authToken");

      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/order/${order.orderId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const orderData = response.data;
        setInvoiceData(orderData);
        setShowInvoicePopup(true);
      } else {
        alert("Could not fetch invoice details");
      }
    } catch (error) {
      console.error("Failed to fetch invoice:", error);
      alert("Failed to load invoice. Please try again.");
    } finally {
      setLoadingInvoice(false);
    }
  };

  // Fetch waiter info for dine-in/takeaway
  const fetchWaiterInfo = async (orderId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        setWaiterInfo({
          name: "Rajesh Kumar",
          role: "Senior Waiter",
          phone: "+91 98765 12345",
          rating: 4.9,
          photo: "https://randomuser.me/api/portraits/men/2.jpg",
          section: "Section A"
        });
        setTableInfo({
          number: Math.floor(Math.random() * 20) + 1,
          type: "Premium",
          capacity: 4
        });
        resolve();
      }, 500);
    });
  };

  const openTrackingPopup = async (order) => {
    setTrackingOrder(order);
    setShowTrackingPopup(true);

    // Reset states
    setDeliveryPartner(null);
    setDeliveryRoute(null);
    setCurrentPosition(null);
    setRestaurantPosition(null);
    setDestinationPosition(null);
    setEstimatedTime(null);

    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }

    if (order.orderType === "DELIVERY") {
      await setupDeliveryTracking(order);
    } else {
      setLoadingTracking(true);
      await fetchWaiterInfo(order.orderId);
      setTrackingProgress(getOrderProgress(order.status));
      setLoadingTracking(false);
    }
  };

  const closeTrackingPopup = () => {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }
    setShowTrackingPopup(false);
    setTrackingOrder(null);
    setTrackingProgress(0);
    setDeliveryPartner(null);
    setWaiterInfo(null);
    setTableInfo(null);
    setEstimatedTime(null);
    setDeliveryRoute(null);
    setCurrentPosition(null);
    setRestaurantPosition(null);
    setDestinationPosition(null);
  };

  const openRatingPopup = (order) => {
    setSelectedOrder(order);
    setRating(order.ratings || 0);
    setFeedback(order.feedback || "");
    setShowRatingPopup(true);
  };

  const closeRatingPopup = () => {
    setShowRatingPopup(false);
    setSelectedOrder(null);
    setRating(0);
    setFeedback("");
    setHoverRating(0);
  };

  const closeSupportPopup = () => {
    setShowSupportPopup(false);
    setOrderId(null);
    setTicketType("");
    setMessage("");
  };

  const closeInvoicePopup = () => {
    setShowInvoicePopup(false);
    setInvoiceData(null);
    setOrderId(null);
  };
  const submitRating = async () => {
    if (!selectedOrder) {
      alert("No order selected for rating.");
      return;
    }

    if (rating === 0) {
      alert("Please select a rating before submitting.");
      return;
    }

    setIsSubmittingRating(true);

    try {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken");

      // ✅ FIXED PAYLOAD (important changes)
      const payload = {
        userId: Number(userId),
        orderId: Number(selectedOrder.orderId),
        rating: rating,
        feedback: feedback || "",
        ratingCategory: "FOOD_QUALITY" // ✅ FIXED
      };

      const endpoint = `https://backend.maamaas.com/food/api/orders/feedback/${selectedOrder.orderId}`;

      console.log("Sending payload:", payload);

      const response = await fetch(endpoint, {
        method: "PUT", // ✅ MOST LIKELY CORRECT
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(payload),
      });

      const responseText = await response.text();
      console.log("Server response:", responseText);

      if (!response.ok) {
        throw new Error(responseText);
      }

      // ✅ UI Update
      const updatedOrders = orders.map((o) =>
        o.orderId === selectedOrder.orderId
          ? {
            ...o,
            rating: rating,
            feedback: feedback || "",
          }
          : o
      );

      setOrders(updatedOrders);
      setFilteredOrders(updatedOrders);

      closeRatingPopup();
      alert("✅ Thank you for your feedback!");

    } catch (error) {
      console.error("Error submitting rating:", error);
      alert(`❌ Failed: ${error.message}`);
    } finally {
      setIsSubmittingRating(false);
    }
  };

  const renderStars = (currentRating, interactive = false) => {
    return (
      <div className="premiumOrder-starsContainer">
        {[1, 2, 3, 4, 5].map((num) => (
          <span
            key={num}
            className={`premiumOrder-star ${interactive ? 'premiumOrder-interactive' : ''}`}
            style={{
              color: num <= (interactive ? hoverRating || rating : currentRating) ? "#ffc107" : "#e4e5e9",
              cursor: interactive ? "pointer" : "default",
              fontSize: interactive ? "32px" : "16px",
              marginRight: interactive ? "8px" : "2px"
            }}
            onClick={() => interactive && setRating(num)}
            onMouseEnter={() => interactive && setHoverRating(num)}
            onMouseLeave={() => interactive && setHoverRating(0)}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  const getStatusColor = (status) => {
    const statusColors = {
      HOLD: "#f39c12",
      PENDING: "#f39c12",
      CONFIRMED: "#3498db",
      PROCESSING: "#9b59b6",
      BEING_PREPARED: "#ee6521",
      ORDER_IS_READY: "#2ecc71",
      WAITING_FOR_PICKUP: "#e67e22",
      ON_THE_WAY: "#1abc9c",
      DELIVERED: "#27ae60",
      COMPLETED: "#27ae60",
      CANCELLED: "#e74c3c"
    };
    return statusColors[status] || "#95a5a6";
  };

  const getPaymentIcon = (method) => {
    const icons = {
      CREDIT_CARD: "💳",
      DEBIT_CARD: "💳",
      UPI: "📱",
      CASH: "💵",
      WALLET: "👛",
      Maamaas_Wallet: "👛"
    };
    return icons[method] || "💳";
  };

  const getStatusDisplayText = (status) => {
    const statusTexts = {
      HOLD: "On Hold",
      PENDING: "Pending",
      CONFIRMED: "Confirmed",
      PROCESSING: "Processing",
      BEING_PREPARED: "Being Prepared",
      ORDER_IS_READY: "Ready for Pickup",
      WAITING_FOR_PICKUP: "Waiting for Pickup",
      ON_THE_WAY: "On the Way",
      DELIVERED: "Delivered",
      COMPLETED: "Completed",
      CANCELLED: "Cancelled"
    };
    return statusTexts[status] || status;
  };

  const getTrackingSteps = (orderType, progress) => {
    if (orderType === "DELIVERY") {
      return [
        { minProgress: 0, label: "Order Confirmed",  },
        { minProgress: 20, label: "Preparing Food",  },
        { minProgress: 40, label: "Ready for Pickup",  },
        { minProgress: 60, label: "Pickup Done",  },
        { minProgress: 80, label: "On The Way",  },
        { minProgress: 100, label: "Delivered",  }
      ];
    } else if (orderType === "DINE_IN") {
      return [
        { minProgress: 0, label: "Order Confirmed",  },
        { minProgress: 25, label: "Preparing Food",  },
        { minProgress: 50, label: "Ready to Serve",  },
        { minProgress: 75, label: "Served",  },
        { minProgress: 100, label: "Completed",  }
      ];
    } else {
      return [
        { minProgress: 0, label: "Order Confirmed", },
        { minProgress: 25, label: "Preparing Food", },
        { minProgress: 50, label: "Ready for Pickup",  },
        { minProgress: 75, label: "Picked Up",  },
        { minProgress: 100, label: "Completed", }
      ];
    }
  };

  return (
    <div className="premiumOrder-root">
      <div className="premiumOrder-container">
        {/* Filters Section */}
        <div className="premiumOrder-filtersWrapper">
          <div className="premiumOrder-filtersBar">
            <button
              className="premiumOrder-filterToggle"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              <FaFilter />
              <span>Advanced Filters</span>
              <FaChevronDown className={isFilterOpen ? "premiumOrder-rotate" : ""} />
            </button>

            <button className="premiumOrder-clearFilters" onClick={clearFilters}>
              Clear All
            </button>
          </div>

          {isFilterOpen && (
            <div className="premiumOrder-filterPanel">
              <div className="premiumOrder-filterGrid">
                <div className="premiumOrder-dateGroup">
                  <select
                    className="premiumOrder-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                  >
                    <option value="">Select Year</option>
                    <option value="2026">2026</option>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                  </select>

                  <select
                    className="premiumOrder-select"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                  >
                    <option value="">Select Month</option>
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>

                  <select
                    className="premiumOrder-select"
                    value={selectedWeek}
                    onChange={(e) => setSelectedWeek(e.target.value)}
                  >
                    <option value="">Select Week</option>
                    <option value="1">Week 1</option>
                    <option value="2">Week 2</option>
                    <option value="3">Week 3</option>
                    <option value="4">Week 4</option>
                    <option value="5">Week 5</option>
                  </select>
                </div>

                <select
                  className="premiumOrder-select"
                  value={filters.orderType}
                  onChange={(e) => handleFilterChange("orderType", e.target.value)}
                >
                  <option value="">All Order Types</option>
                  {orderTypeOptions.map(type => (
                    <option key={type} value={type}>{type.replace('_', ' ')}</option>
                  ))}
                </select>

                <select
                  className="premiumOrder-select"
                  value={filters.paymentMethod}
                  onChange={(e) => handleFilterChange("paymentMethod", e.target.value)}
                >
                  <option value="">All Payment Methods</option>
                  {paymentOptions.map(method => (
                    <option key={method} value={method}>{method.replace('_', ' ')}</option>
                  ))}
                </select>

                <select
                  className="premiumOrder-select"
                  value={filters.status}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                >
                  <option value="">All Status</option>
                  {statusOptions.map(status => (
                    <option key={status} value={status}>{status.replace('_', ' ')}</option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>

        {/* Desktop Table View */}
        <div className="premiumOrder-tableWrapper">
          <table className="premiumOrder-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date & Time</th>
                <th>Item</th>
                <th>Type</th>
                <th>Payment</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Rating</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map((order, index) => (
                  <tr key={index}>
                    <td className="premiumOrder-tableId">#{order.orderId}</td>
                    <td>
                      <div>{new Date(order.orderDateAndTime).toLocaleDateString()}</div>
                      <div className="premiumOrder-tableTime">
                        {new Date(order.orderDateAndTime).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </div>
                    </td>
                    <td>{order.dishName}</td>
                    <td>{order.orderType?.replace("_", " ")}</td>
                    <td>
                      <span className="premiumOrder-paymentMethod">
                        {getPaymentIcon(order.paymentMethod)} {order.paymentMethod?.replace("_", " ")}
                      </span>
                    </td>
                    <td className="premiumOrder-tableAmount">₹{Number(order.grandTotal).toFixed(0)}</td>
                    <td>
                      <div className="premiumOrder-statusCell">
                        <span
                          className="premiumOrder-statusBadge"
                          style={{ backgroundColor: getStatusColor(order.status) }}
                        >
                          {getStatusDisplayText(order.status)}
                        </span>
                      </div>
                    </td>
                    <td>
                      {(order.rating || order.ratings) ? (
                        <div className="premiumOrder-ratingCell">
                          {renderStars(order.rating || order.ratings)}
                          <span className="premiumOrder-ratingNumber">
                            ({order.rating || order.ratings}/5)
                          </span>
                        </div>
                      ) : (
                        <span className="premiumOrder-notRated">—</span>
                      )}
                    </td>
                    <td>
                      <div className="premiumOrder-tableActions">
                        <button
                          className="premiumOrder-actionBtn premiumOrder-trackAction"
                          onClick={() => openTrackingPopup(order)}
                          title="Track Order"
                        >
                          {order.orderType === "DELIVERY" ? <FaMotorcycle /> : <FaConciergeBell />}
                        </button>

                        <button
                          className="premiumOrder-actionBtn premiumOrder-invoiceAction"
                          onClick={() => handleViewInvoice(order)}
                          disabled={loadingInvoice}
                          title="View Invoice"
                        >
                          {loadingInvoice && orderId === order.orderId ? (
                            <FaSpinner className="premiumOrder-spinner" />
                          ) : (
                            <FaFileInvoice />
                          )}
                        </button>

                        {(order.status === 'DELIVERED' || order.status === 'COMPLETED') && (
                          <button
                            className="premiumOrder-actionBtn premiumOrder-rateAction"
                            onClick={() => openRatingPopup(order)}
                            title={order.ratings ? "Update Rating" : "Rate Order"}
                          >
                            <FaStar />
                          </button>
                        )}

                        {order.status !== 'CANCELLED' && (
                          <button
                            className="premiumOrder-actionBtn premiumOrder-supportAction"
                            onClick={() => {
                              setShowSupportPopup(true);
                              setOrderId(order.orderId);
                            }}
                            title="Get Support"
                          >
                            <FaCheckCircle />
                          </button>
                        )}

                        <button
                          className="premiumOrder-actionBtn premiumOrder-reorderAction"
                          onClick={() => {
                            const vId = order.vendorId || order.vendor_id;
                            if (!vId) {
                              alert("Vendor ID missing");
                              return;
                            }
                            navigate(`/Tablemainfile/${vId}`);
                          }}
                          title="Reorder"
                        >
                          <FaRedo />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="premiumOrder-noData">
                    No Orders Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards View */}
        <div className="premiumOrder-cardsWrapper">
          <div className="premiumOrder-cards">
            {currentOrders.length > 0 ? (
              currentOrders.map((order, index) => (
                <div key={index} className="premiumOrder-card">
                  <div className="premiumOrder-cardHeader">
                    <span className="premiumOrder-cardId">#{order.orderId}</span>
                    <span 
                      className="premiumOrder-cardStatus"
                      style={{ backgroundColor: getStatusColor(order.status) }}
                    >
                      {getStatusDisplayText(order.status)}
                    </span>
                  </div>
                  
                  <div className="premiumOrder-cardBody">
                    <div className="premiumOrder-cardRow">
                      <span className="premiumOrder-cardIcon">📅</span>
                      <span className="premiumOrder-cardLabel">Date & Time</span>
                      <span className="premiumOrder-cardValue">
                        {new Date(order.orderDateAndTime).toLocaleDateString()} • {new Date(order.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                    
                    <div className="premiumOrder-cardRow">
                      <span className="premiumOrder-cardIcon">🍽️</span>
                      <span className="premiumOrder-cardLabel">Item</span>
                      <span className="premiumOrder-cardValue">{order.dishName}</span>
                    </div>
                    
                    <div className="premiumOrder-cardRow">
                      <span className="premiumOrder-cardIcon">📋</span>
                      <span className="premiumOrder-cardLabel">Order Type</span>
                      <span className="premiumOrder-cardValue">{order.orderType?.replace("_", " ")}</span>
                    </div>
                    
                    <div className="premiumOrder-cardRow">
                      <span className="premiumOrder-cardIcon">💳</span>
                      <span className="premiumOrder-cardLabel">Payment</span>
                      <span className="premiumOrder-cardValue">
                        {getPaymentIcon(order.paymentMethod)} {order.paymentMethod?.replace("_", " ")}
                      </span>
                    </div>
                    
                    <div className="premiumOrder-cardAmount">
                      <span className="premiumOrder-cardLabel">Total Amount</span>
                      <span className="premiumOrder-price">₹{Number(order.grandTotal).toFixed(0)}</span>
                    </div>
                    
                    {(order.rating || order.ratings) && (
                      <div className="premiumOrder-cardRating">
                        <span className="premiumOrder-cardLabel">Rating</span>
                        <div className="premiumOrder-starsContainer">
                          {renderStars(order.rating || order.ratings)}
                        </div>
                        <span className="premiumOrder-ratingNumber">({order.rating || order.ratings}/5)</span>
                      </div>
                    )}
                  </div>
                  
                  <div className="premiumOrder-cardFooter">
                    <button
                      className="premiumOrder-cardBtn premiumOrder-trackCardBtn"
                      onClick={() => openTrackingPopup(order)}
                    >
                      {order.orderType === "DELIVERY" ? <FaMotorcycle /> : <FaConciergeBell />}
                      Track
                    </button>
                    
                    <button
                      className="premiumOrder-cardBtn premiumOrder-invoiceCardBtn"
                      onClick={() => handleViewInvoice(order)}
                      disabled={loadingInvoice}
                    >
                      {loadingInvoice && orderId === order.orderId ? (
                        <FaSpinner className="premiumOrder-spinner" />
                      ) : (
                        <FaFileInvoice />
                      )}
                      Invoice
                    </button>
                    
                    {(order.status === 'DELIVERED' || order.status === 'COMPLETED') && (
                      <button
                        className="premiumOrder-cardBtn premiumOrder-rateCardBtn"
                        onClick={() => openRatingPopup(order)}
                      >
                        <FaStar /> Rate
                      </button>
                    )}
                    
                    {order.status !== 'CANCELLED' && (
                      <button
                        className="premiumOrder-cardBtn premiumOrder-supportCardBtn"
                        onClick={() => {
                          setShowSupportPopup(true);
                          setOrderId(order.orderId);
                        }}
                      >
                        <FaCheckCircle /> Support
                      </button>
                    )}
                    
                    <button
                      className="premiumOrder-cardBtn premiumOrder-reorderCardBtn"
                      onClick={() => {
                        const vId = order.vendorId || order.vendor_id;
                        if (!vId) {
                          alert("Vendor ID missing");
                          return;
                        }
                        navigate(`/Tablemainfile/${vId}`);
                      }}
                    >
                      <FaRedo /> Reorder
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="premiumOrder-noData">
                No Orders Found
              </div>
            )}
          </div>
        </div>

        {filteredOrders.length > 0 && (
          <div className="premiumOrder-pagination">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="premiumOrder-pageBtn"
            >
              Previous
            </button>
            <span className="premiumOrder-pageInfo">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="premiumOrder-pageBtn"
            >
              Next
            </button>
          </div>
        )}
      </div>

      {/* Tracking Popup */}
      {showTrackingPopup && trackingOrder && (
        <div className="premiumOrder-popupOverlay" onClick={closeTrackingPopup}>
          <div className="premiumOrder-popup premiumOrder-trackingPopup" onClick={(e) => e.stopPropagation()}>
            <div className="premiumOrder-popupHeader">
              <h3>
                {trackingOrder.orderType === "DELIVERY" ? (
                  <FaMotorcycle className="premiumOrder-headerIcon" />
                ) : (
                  <FaConciergeBell className="premiumOrder-headerIcon" />
                )}
                Live Order Tracking
                {trackingOrder.orderType === "DINE_IN" && " (Dine-In)"}
                {trackingOrder.orderType === "TAKEAWAY" && " (Takeaway)"}
                {trackingOrder.orderType === "DELIVERY" && " (Delivery)"}
              </h3>
              <button className="premiumOrder-popupClose" onClick={closeTrackingPopup}>
                <FaTimes />
              </button>
            </div>

            <div className="premiumOrder-trackingContent">
              {loadingTracking ? (
                <div className="premiumOrder-loadingTracking">
                  <FaSpinner className="premiumOrder-spinner" />
                  <p>Loading tracking details...</p>
                </div>
              ) : (
                <>
                  <div className="premiumOrder-trackingSummary">
                    <div className="premiumOrder-trackingOrderId">Order #{trackingOrder.orderId}</div>
                    <div className="premiumOrder-trackingItems">{trackingOrder.dishName}</div>
                    <div className="premiumOrder-trackingTotal">Total: ₹{Number(trackingOrder.grandTotal).toFixed(0)}</div>
                  </div>

                  {/* Live Google Maps for Delivery */}
                  {trackingOrder.orderType === "DELIVERY" && isGoogleMapsLoaded && (
                    <DeliveryMap
                      restaurantPosition={restaurantPosition}
                      destinationPosition={destinationPosition}
                      currentPosition={currentPosition}
                      deliveryRoute={deliveryRoute}
                    />
                  )}

                  {/* Progress Timeline */}
                  <div className="premiumOrder-trackingTimeline">
                    <div className="premiumOrder-trackingProgressBar">
                      <div
                        className="premiumOrder-trackingProgressFill"
                        style={{ width: `${trackingProgress}%` }}
                      ></div>
                    </div>

                    <div className="premiumOrder-trackingSteps">
                      {getTrackingSteps(trackingOrder.orderType, trackingProgress).map((step, idx) => (
                        <div
                          key={idx}
                          className={`premiumOrder-trackingStepItem ${trackingProgress >= step.minProgress ? 'active' : ''}`}
                        >
                          <div className="premiumOrder-trackingStepDot"></div>
                          <div className="premiumOrder-trackingStepText">
                            <strong>{step.label}</strong>
                            <span>{step.description}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="premiumOrder-trackingMap">
                    <div className="premiumOrder-mapSimulation">
                      <div className="premiumOrder-mapRoute">
                        <div className="premiumOrder-mapPoint premiumOrder-startPoint">
                          {trackingOrder.orderType === "DELIVERY" ? <FaStore /> : <FaUtensils />}
                          <span>{trackingOrder.orderType === "DELIVERY" ? "Restaurant" : "Restaurant"}</span>
                        </div>
                        <div className="premiumOrder-mapLine">
                          <div className="premiumOrder-mapLineFill" style={{ width: `${trackingProgress}%` }}></div>
                        </div>
                        <div className="premiumOrder-mapPoint premiumOrder-endPoint">
                          {trackingOrder.orderType === "DELIVERY" ? <FaHome /> : <FaChair />}
                          <span>{trackingOrder.orderType === "DELIVERY" ? "Your Location" : "Your Table"}</span>
                        </div>
                      </div>

                      {/* Moving icon based on order type */}
                      {trackingProgress < 100 && trackingProgress > 0 && (
                        <div
                          className="premiumOrder-movingDelivery"
                          style={{ left: `${trackingProgress}%` }}
                        >
                          {trackingOrder.orderType === "DELIVERY" ? (
                            <FaMotorcycle className="premiumOrder-movingIcon" />
                          ) : (
                            <FaWalking className="premiumOrder-movingIcon" />
                          )}
                        </div>
                      )}
                    </div>
                  </div>


                  {/* Delivery Partner Info */}
                  {trackingOrder.orderType === "DELIVERY" && deliveryPartner && (
                    <div className="premiumOrder-deliveryPartner">
                      <h4>Delivery Partner</h4>
                      <div className="premiumOrder-partnerInfo">
                        <div className="premiumOrder-partnerPhoto">
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                            alt="Delivery Partner"
                          />
                        </div>
                        <div className="premiumOrder-partnerDetails">
                          <div className="premiumOrder-partnerName">
                            {deliveryPartner.name || "Delivery Partner"}
                          </div>
                          <div className="premiumOrder-partnerVehicle">
                            {deliveryPartner.vehicleNumber === "TWO_WHEELER" ? "Bike 🏍️" : "Car 🚗"}
                          </div>
                          {estimatedTime && (
                            <div className="premiumOrder-estimatedTime">
                              <FaClock /> ETA: {estimatedTime}
                            </div>
                          )}
                        </div>
                        <div className="premiumOrder-partnerActions">
                          <button className="premiumOrder-callBtn" onClick={() => {
                            if (deliveryPartner.phone) {
                              window.location.href = `tel:${deliveryPartner.phone}`;
                            }
                          }}>
                            <FaPhoneAlt /> Call
                          </button>
                        </div>
                      </div>
                      <div className="premiumOrder-otpSection">
                        <div className="premiumOrder-otpBox">
                          <strong>Delivery OTP:</strong> {deliveryPartner.userOtp}
                        </div>
                      </div>
                    </div>
                  )}

                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Rating Popup */}
      {showRatingPopup && selectedOrder && (
        <div className="premiumOrder-popupOverlay" onClick={closeRatingPopup}>
          <div className="premiumOrder-popup" onClick={(e) => e.stopPropagation()}>
            <div className="premiumOrder-popupHeader">
              <h3>Rate Your Order</h3>
              <button className="premiumOrder-popupClose" onClick={closeRatingPopup}>
                <FaTimes />
              </button>
            </div>
            <div className="premiumOrder-popupBody">
              <div className="premiumOrder-orderInfo">
                <p><strong>Order ID:</strong> #{selectedOrder.orderId}</p>
                <p><strong>Item:</strong> {selectedOrder.dishName}</p>
                <p><strong>Date:</strong> {new Date(selectedOrder.orderDateAndTime).toLocaleDateString()}</p>
                <p><strong>Amount:</strong> ₹{Number(selectedOrder.grandTotal).toFixed(0)}</p>
              </div>
              <div className="premiumOrder-ratingSection">
                <h4>How would you rate this order?</h4>
                <div className="premiumOrder-starsRating">
                  {renderStars(rating, true)}
                </div>
              </div>
              <div className="premiumOrder-feedbackSection">
                <h4>Your Feedback (Optional)</h4>
                <textarea
                  className="premiumOrder-textarea"
                  placeholder="Share your experience with this order..."
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  rows="4"
                />
              </div>
            </div>
            <div className="premiumOrder-popupFooter">
              <button
                className="premiumOrder-submitBtn"
                onClick={submitRating}
                disabled={isSubmittingRating}
              >
                {isSubmittingRating ? <FaSpinner className="premiumOrder-spinner" /> : "Submit Rating"}
              </button>
              <button
                className="premiumOrder-cancelBtn"
                onClick={closeRatingPopup}
                disabled={isSubmittingRating}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Support Popup */}
      {showSupportPopup && (
        <div className="premiumOrder-popupOverlay" onClick={closeSupportPopup}>
          <div className="premiumOrder-popup premiumOrder-supportPopup" onClick={(e) => e.stopPropagation()}>
            <div className="premiumOrder-popupHeader">
              <h3>Raise Support Ticket</h3>
              <button className="premiumOrder-popupClose" onClick={closeSupportPopup}>
                <FaTimes />
              </button>
            </div>
            <div className="premiumOrder-popupBody">
              <div className="premiumOrder-orderReference">
                <strong>Order ID:</strong> #{orderId}
              </div>
              <div className="premiumOrder-formGroup">
                <label>Issue Type *</label>
                <select
                  value={ticketType}
                  onChange={(e) => setTicketType(e.target.value)}
                  className="premiumOrder-select"
                >
                  <option value="">Select issue type</option>
                  {ticketTypeOptions.map(type => (
                    <option key={type} value={type}>{type.replace('_', ' ')}</option>
                  ))}
                </select>
              </div>
              <div className="premiumOrder-formGroup">
                <label>Message *</label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Please describe your issue in detail..."
                  className="premiumOrder-textarea"
                  rows="4"
                />
              </div>
              <div className="premiumOrder-formGroup">
                <label>Attachment (Optional)</label>
                <div className="premiumOrder-fileUpload">
                  <input
                    type="file"
                    onChange={(e) => setFile(e.target.files[0])}
                    id="file-upload-premium"
                  />
                  <label htmlFor="file-upload-premium" className="premiumOrder-fileLabel">
                    <FaPaperclip />
                    Choose File
                  </label>
                  {file && <span className="premiumOrder-fileName">✓ {file.name}</span>}
                </div>
              </div>
            </div>
            <div className="premiumOrder-popupFooter">
              <button className="premiumOrder-cancelBtn" onClick={closeSupportPopup}>
                Cancel
              </button>
              <button
                className="premiumOrder-submitBtn"
                onClick={handleSend}
                disabled={!ticketType || !message}
              >
                Send Ticket
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Invoice Popup */}
      <InvoicePopup
        isOpen={showInvoicePopup}
        onClose={closeInvoicePopup}
        orderData={invoiceData}
      />
    </div>
  );
};

export default OrderPremium;